const _strings = {
  'katal-statusindicator-success': {
    'en-US': 'Success: {label}',
  },
  'katal-statusindicator-error': {
    'en-US': 'Error: {label}',
  },
  'katal-statusindicator-alert': {
    'en-US': 'Warning: {label}',
  },
  'katal-statusindicator-information': {
    'en-US': 'Information: {label}',
  },
  'katal-statusindicator-pending': {
    'en-US': 'Pending: {label}',
  },
  'katal-statusindicator-loading': {
    'en-US': 'Loading: {label}',
  },
};

export default _strings;
